import { RESET_BOOKING_STEP_URLS, SAVE_BOOKING_STEP_URL } from "./bookingStepUrlsActionTypes";
import { BookingStepKey } from "../constants/bookingSteps";

export type SaveBookingStepUrlAction = {
	type: typeof SAVE_BOOKING_STEP_URL;
	step: BookingStepKey;
	url: string;
};

export type ResetBookingStepUrlsAction = {
	type: typeof RESET_BOOKING_STEP_URLS;
};

export type BookingStepUrlsAction = SaveBookingStepUrlAction | ResetBookingStepUrlsAction;

export const saveBookingStepUrl = (
	step: BookingStepKey,
	url: string
): SaveBookingStepUrlAction => ({
	type: SAVE_BOOKING_STEP_URL,
	step,
	url,
});

export const resetBookingStepUrls = (): ResetBookingStepUrlsAction => ({
	type: RESET_BOOKING_STEP_URLS,
});
